import { render, staticRenderFns } from "./sound-diffuser.vue?vue&type=template&id=5e48bf2e&"
import script from "./sound-diffuser.vue?vue&type=script&lang=js&"
export * from "./sound-diffuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports